<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Appointment Manage</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-1">
          <p-button class="no-margin" type="default" block outline round  @click="openAddModal()"> <i class="fa fa-plus"></i> </p-button>
        </div>
        <div class="col-sm-5"  v-if="pagination">
          <el-select
            class="select-default"
            v-model="pagination.per_page"
            placeholder="Per page"
            @change="changePerPage()"
          >
            <el-option
              class="select-default"
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="tableData"
            border
            style="width: 100%;"
            height="600"
          >
            <el-table-column
              v-for="(column) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :fixed="column.fixed || false"
              :formatter="column.formatter || null"
            ></el-table-column>

            <el-table-column :min-width="150" fixed="right" class-name="td-actions" label="Actions">
              <template slot-scope="props">
                <!-- <p-button type="info" size="sm" icon @click="handleLike(props.$index, props.row)">
                  <i class="fa fa-eye"></i>
                </p-button> -->
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info"  v-if="pagination">
          <p
            class="category"
          >Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</p>
        </div>
        <div class="col-sm-6"  v-if="pagination">
          <p-pagination
            class="pull-right"
            v-model="pagination.current_page"
            :per-page="Number.parseInt(pagination.per_page)"
            :total="pagination.total"
            @input="changePage()"
          ></p-pagination>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.add"
      headerClasses="justify-content-center"
      footer-classes="justify-content-center"
      >
      <h5 slot="header" class="modal-title">Manage Appointment</h5>
      <form>
        <div class="row">
          <div class="form-group col-6">
            <label for>Location</label>
            <fg-input
              name="location_id"
              v-model="model.location_id"
              v-validate="modelValidations.location_id"
              :error="getError('location_id')"
            >
              <el-select
                name="location_id"
                :class="!getError('location_id') ? 'select-default' : 'select-danger'"
                placeholder="Select Location"
                v-model="model.location_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in locations"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.location_id} - ${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Patient</label>
            <fg-input
              name="patient_id"
              v-model="model.patient_id"
              v-validate="modelValidations.patient_id"
              :error="getError('patient_id')"
            >
              <el-select
                name="patient_id"
                :class="!getError('patient_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Patient"
                v-model="model.patient_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in all_patients"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.patient_id} - ${option.name} -  ${option.phone}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Doctor</label>
            <fg-input
              name="doctor_id"
              v-model="model.doctor_id"
              v-validate="modelValidations.doctor_id"
              :error="getError('doctor_id')"
            >
              <el-select
                name="doctor_id"
                :class="!getError('doctor_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Doctor"
                v-model="model.doctor_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in doctors"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.employee_id} - ${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Type</label>
            <fg-input
              name="appointment_type"
              v-model="model.appointment_type"
              v-validate="modelValidations.appointment_type"
              :error="getError('appointment_type')"
            >
              <el-select
                name="appointment_type"
                :class="!getError('appointment_type') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Appointment Type"
                v-model="model.appointment_type"
                filterable
              >
                <el-option
                  v-for="(option, index) in appointmentTypes"
                  class="select-success"
                  :value="option"
                  :label="`${option}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Date</label>
            <fg-input
              name="datetime"
              v-model="model.datetime"
              v-validate="modelValidations.datetime"
              :error="getError('datetime')"
            >
              <!-- <el-date-picker v-model="model.date" type="date" placeholder="Pick a day" :picker-options="datePickerOptions"></el-date-picker> -->
              <el-date-picker v-model="model.datetime" type="datetime" placeholder="Select date and time"></el-date-picker>
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Notes</label>
            <fg-input
              name="note"
              v-model="model.note"
              v-validate="modelValidations.note"
              :error="getError('note')"
            ></fg-input>
          </div>


        </div>
      </form>
      <template slot="footer">
        <p-button type="success" @click="validate()">Save</p-button>
      </template>
    </modal>


  </div>
</template>


<script>
import Vue from "vue";
import { Modal } from "src/components/UIComponents";
import { Table, TableColumn, Select, Option, Slider, DatePicker, TimeSelect } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Slider);

export default {
  components: {
    [TimeSelect.name]: TimeSelect,
    [DatePicker.name]: DatePicker,
    PPagination,
    Modal
  },
  mounted() {
    this.$store.dispatch("fetchAppointments", { per_page: 10, page: 1 });
    this.$store.dispatch("fetchLocationsAll");
    this.$store.dispatch("fetchSimplePatientsAll");
    this.$store.dispatch("fetchLeadsAll");
    this.$store.dispatch("fetchDoctorsAll");
    this.$store.dispatch("fetchAppointmentType");

    if(this.$route.params.appointment_id){
      this.$store.dispatch("fetchAppointment", this.$route.params.appointment_id);
    }
  },
  computed: {
    ...mapGetters({
      tableData: "getAppointments",
      pagination: "getPagination",
      locations: "getLocations",
      patients: "getPatients",
      leads: "getLeads",
      doctors: "getDoctors",
      appointmentTypes: "getAppointmentTypes",
      appointment: "getAppointment"
    }),
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   if(this.locations)
      //   this.pagination.total = this.locations.length;
      //   else
      //   this.pagination.total = 0
      //   return this.pagedData;
      // }
      // let result = this.locations.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    },
    all_patients(){
      return [...this.patients, ...this.leads]
    }
  },
  watch: {
    // whenever question changes, this function will run
    appointment: function (newAppointment, oldAppointment) {
      this.model.id = newAppointment.id;
      this.model.appointment_id = newAppointment.appointment_id;
      this.model.location_id = newAppointment.location.id;
      this.model.patient_id = newAppointment.patient.id;
      this.model.doctor_id = newAppointment.doctor.id;
      this.model.appointment_type = newAppointment.appointment_type;
      this.model.datetime = newAppointment.datetime;
      this.model.note = newAppointment.note;
      this.scope = 'edit';
      this.modals.add = true;
    },
     searchQuery: function (val) {
          this.$store.dispatch("fetchAppointments", {
              searchQuery: this.searchQuery,
              per_page: this.pagination.per_page,
              page: this.pagination.current_page
          }); 
      }
  },
  data() {
    return {
      modals: {
        add: false,
      },
      scope: 'add',
      datePickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: 'Tomorrow',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 1)
            picker.$emit('pick', date)
          }
        },
        {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      perPageOptions: ["10", "30", "50", "100", "250", "500"],
      searchQuery: "",
      propsToSearch: [
        "patient_id",
        "patient_name",
        "location_id",
        "location_name",
        "doctor_id",
        "doctor_name",
        "appointment_type",
        "datetime",
        "note",
      ],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
          hidden: true,
          align: "center"
        },
        {
          prop: "appointment_id",
          label: "Appt ID",
          minWidth: 150,
          fixed: true,
          sortable: true,
          align: "center"
        },
        {
          prop: "location.location_id",
          label: "LOC ID",
          minWidth: 150,
          fixed: false,
          sortable: true,
          align: "center"
        },
        {
          prop: "location.name",
          label: "Location Name",
          minWidth: 250,
          sortable: true,
          align: "left"
        },
        {
          prop: "patient.patient_id",
          label: "Pat ID",
          minWidth: 150,
          fixed: false,
          sortable: true,
          align: "center"
        },
        {
          prop: "patient.name",
          label: "Patient Name",
          minWidth: 250,
          sortable: true,
          align: "left"
        },
        {
          prop: "doctor.employee_id",
          label: "Doc ID",
          minWidth: 150,
          fixed: false,
          sortable: true,
          align: "center"
        },
        {
          prop: "doctor.name",
          label: "Doctor Name",
          minWidth: 250,
          sortable: true,
          align: "left"
        },
        {
          prop: "appointment_type",
          label: "Type",
          minWidth: 200,
          align: "center"
        },
        {
          prop: "datetime",
          label: "Date & Time",
          minWidth: 300,
          align: "center",
          formatter: function(row, column, cellValue, index){
            var d = new Date(row.datetime);
            var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
          }
        },
        {
          prop: "note",
          label: "Note",
          minWidth: 250,
          align: "left"
        }
      ],
      model: {
        id: null,
        location_id: null,
        patient_id: null,
        doctor_id: null,
        appointment_type: null,
        datetime: null,
        note: null
      },
      modelValidations: {
        location_id: {
          required: true
        },
        patient_id: {
          required: true
        },
        doctor_id: {
          required: true
        },
        appointment_type: {
          required: true
        },
        datetime: {
          required: true
        },
        note: {
          required: false
        },
      }
      // tableData: this.locations
    };
  },
  methods: {
    changePerPage() {
      this.$store.dispatch("fetchAppointments", {
        per_page: this.pagination.per_page,
        page: 1,
        searchQuery: this.searchQuery,
      });
    },
    changePage() {
      this.$store.dispatch("fetchAppointments", {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page,
        searchQuery: this.searchQuery,
      });
    },
    handleEdit(index, row) {
      // this.$router.push(`/products/edit/${row.id}`);
      this.model.id = row.id;
      this.model.appointment_id = row.appointment_id;
      this.model.location_id = row.location.id;
      this.model.patient_id = row.patient.id;
      this.model.doctor_id = row.doctor.id;
      this.model.appointment_type = row.appointment_type;
      this.model.datetime = row.datetime;
      this.model.note = row.note;
      this.scope = 'edit';
      this.modals.add = true;
      // this.$store.dispatch("createAppointment", this.model);
    },
    handleDelete(index, row) {
      // this.$store.dispatch("deleteAppointment", row.id);
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { this.$store.dispatch("deleteAppointment", row.id); })
      .catch(cancel => { console.log(cancel) });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.modals.add = false;
          switch(this.scope){
            case 'add'  : this.$store.dispatch("createAppointment", this.model); break;
            case 'edit' : this.$store.dispatch("updateAppointment", this.model); break;
          }
        }
      });      
    },
    openAddModal(){
      this.model.id = null;
      this.model.location_id = null;
      this.model.patient_id = null;
      this.model.doctor_id = null;
      this.model.appointment_type = null;
      this.model.datetime = null;
      this.model.note = null;
      this.scope = 'add';
      this.modals.add = true;
    },
  }
};
</script>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}

button.no-margin{
  margin: 0;
}

.el-table,
.el-table tr,
.el-table thead th {
  background-color: white !important;
}

.form-group .el-input-number {
  width: 35%;
  outline: none;
}
.el-input--small .el-input__inner {
  border-radius: 50px;
}
</style>
